import { defineMessages } from 'react-intl'

export const networkStatusWLANsMessages = defineMessages({
  wlansTotalText: {
    id: 'networkStatusWLANsMessages.wlansTotalText',
    description: 'Title text for WLAN Total',
    defaultMessage: 'Total',
  },
  wlansEnabledText: {
    id: 'networkStatusWLANsMessages.wlansEnabledText',
    description: 'Title text for WLAN Enabled',
    defaultMessage: 'Enabled',
  },
  wlansGuestText: {
    id: 'networkStatusWLANsMessages.wlansGuestText',
    description: 'Title text for WLAN Guest',
    defaultMessage: 'Guest Portal',
  },
})
